module.exports = __webpack_public_path__ + "static/power-img1-3@2x-51739e3f94be119daf320c0acce50d1d.png";